module.exports = __webpack_public_path__ + "static/media/pigment-icon.0b49893e.svg";